import apiClient from './api';
import { Project, NewProject, UpdateProject } from '../types/project';
import { Task } from '../types/task';
import { Expense, PaymentReceived } from '../types/accounting';

interface GetProjectsParams {
  search?: string;
  status?: string;
  mine?: boolean;
}

const getProjects = async (params?: GetProjectsParams): Promise<Project[]> => {
  const response = await apiClient.get<Project[]>('/projects/', { params });
  return response.data;
};

export interface ProjectDetails extends Project {
  tasks: Task[];
  expenses: Expense[];
  payments: PaymentReceived[];
}

const createProject = async (projectData: NewProject): Promise<Project> => {
  const response = await apiClient.post<Project>('/projects/', projectData);
  return response.data;
};

const updateProject = async (id: number, projectData: UpdateProject): Promise<Project> => {
  const response = await apiClient.patch<Project>(`/projects/${id}/`, projectData);
  return response.data;
};

const getProjectDetails = async (id: number): Promise<ProjectDetails> => {
  const response = await apiClient.get<ProjectDetails>(`/projects/${id}/details/`);
  return response.data;
};

export const projectService = {
  getProjects,
  createProject,
  updateProject,
  getProjectDetails,
};